import { combineReducers } from '@reduxjs/toolkit';
import api from '../api/api';

// reducers
import administrationDictionariesReducer from './dictionaries/slice';
import rolesReducer from '../hoc/user-roles/store/slices/roles';
import rolesConfirmReducer from '../hoc/user-roles/store/slices/confirm';
import usersColumnReducer from '../hoc/user-list/store/slices/users';
import userPermissionsReducer from '../hoc/user-list/store/slices/permissions';
import usersConfirmReducer from '../hoc/user-list/store/slices/confirm';
import sidepanelUserReducer from '../hoc/user-list/store/slices/sidepanel';
import currenciesListReducer from '../hoc/settings/store/slices/currencies';
import countriesListReducer from '../hoc/settings/store/slices/countries';
import transactionsTypesReducer from '../hoc/settings/store/slices/transactions-types';
import pspDetailsReducer from '../hoc/settings/store/slices/details';
import agreementsListReducer from '../hoc/settings/store/slices/agreements';
import areementItemReducer from '../hoc/settings/store/slices/agreement-item';
import employeeProfileReducer from '../hoc/settings/profile/store/slices';
import applicationSchemesReducer from '../hoc/settings/store/slices/application-shemes';
import paymentTypesReducer from '../hoc/settings/store/slices/payment-types';
import changeLogsReducer from '../hoc/change-logs/store/slice';
import clientsReducer from '../hoc/clients/store/slice';
import notificationSettingsReducer from '../hoc/notification-settings/store/slices';
import employeeNotificationSettingsReduces from '../hoc/user-list/store/slices/notification-settings';
import securityLocksReducer from '../hoc/security/store/slices/locks';
import securityLogsReducer from '../hoc/security/store/slices/logs';
import anonymisationReducer from '../hoc/anonymisation-logs/store/slice';
import processingRulesReducer from '../hoc/transation-settings/processing-rules/store/slice';
import purposeCodesSettingsReducer from '../hoc/settings/store/slices/purpose-codes';
import dictionariesReducer from '../hoc/dictionaries/store/slice';
import reportsSettingsReducer from '../hoc/settings/store/slices/reports-settings';

// middlewares
import administrationMiddleware from './middlewares';

export const administrationApi = [
  api.middleware,
  administrationMiddleware.middleware,
];

export const administrationReducers = {
  employeesApi: api.reducer,
  administrationDictionaries: administrationDictionariesReducer,
  userRoles: combineReducers({
    roles: rolesReducer,
    confirm: rolesConfirmReducer,
  }),
  userList: combineReducers({
    users: usersColumnReducer,
    permissions: userPermissionsReducer,
    confirm: usersConfirmReducer,
    sidepanel: sidepanelUserReducer,
    notificationSettings: employeeNotificationSettingsReduces,
  }),
  settings: combineReducers({
    currencies: currenciesListReducer,
    countries: countriesListReducer,
    transactionsTypes: transactionsTypesReducer,
    details: pspDetailsReducer,
    agreements: combineReducers({
      list: agreementsListReducer,
      form: areementItemReducer,
    }),
    profile: employeeProfileReducer,
    applicationSchemes: applicationSchemesReducer,
    paymentTypes: paymentTypesReducer,
    processingRules: processingRulesReducer,
  }),
  notificationSettings: combineReducers({
    templates: notificationSettingsReducer,
  }),
  changeLogs: changeLogsReducer,
  clients: clientsReducer,
  security: combineReducers({
    locks: securityLocksReducer,
    logs: securityLogsReducer,
  }),
  anonymisationLogs: anonymisationReducer,
  purposeCodesSettings: purposeCodesSettingsReducer,
  dictionaries: dictionariesReducer,
  reportsSettings: reportsSettingsReducer,
};
